import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class FirGiltiCalcGridService {

  constructor(private http: HttpClient) {}

  saveManualData(
    baseUrl: string,
    rowData: any,
    colId: string,
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=79wgno`;

    const jsonObj = [{
      tax_year: rowData.TAX_YEAR,
      ho_leid: rowData.HO_LEID,
      ho_cdr_no: rowData.HO_CDR_NO,
      filing_group: rowData.FILING_GROUP,
      scenario: rowData.SCENARIO,
      col_type: colId,
      col_value: rowData[colId],
      ho_combination_key: rowData.HO_COMBINATION_KEY,
      shareholder_leid: rowData.SHAREHOLDER_LEID,
      shareholder_cdr_no: rowData.SHAREHOLDER_CDR_NO,
      functional_curr: rowData.FUNCTIONAL_CURRENCY
    }];

    const jsonSettings = [{
      sso_id: globalService?.globalParams?.sso_id || '',
      screen_key: globalService?.globalParams?.screen_key || ''
    }];

    let params: any = _.merge({}, globalService?.globalParams || {}, filterParams);
    params = _.extend({ jsonObj: JSON.stringify(jsonObj) }, params);
    params = _.extend({ jsonSettings: JSON.stringify(jsonSettings) }, params);
    params.object_id = rowData.object_id;
    params.sso_id = globalService?.globalParams?.sso_id || '';
    params.process_name = 'saveManualData';

    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, String(params[key]));
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }

  calculationGridInputs(
    baseUrl: string,
    rowData: any,
    colData: any,
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=j0pcb3`;

    let params: any = _.merge({}, globalService?.globalParams || {}, filterParams);
    params.object_id = rowData.object_id;
    params.filing_group = rowData.FILING_GROUP;
    params.ho_leid = rowData.HO_LEID;
    params.ho_cdr_no = rowData.HO_CDR_NO;
    params.shareholder_leid = rowData.SHAREHOLDER_LEID;
    params.shareholder_cdr_no = rowData.SHAREHOLDER_CDR_NO;
    params.func_curr = rowData.FUNC_CURR;
    params.col_type = colData.map || colData.MAP;
    params.col_val = rowData[colData.map || colData.MAP];
    params.is_issue_key_enabled = 'N';

    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, String(params[key]));
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }
}
